<template>
  <div class="applist-wrapper">
    <div class="wechat-mask" v-if="wechatFlag">
      <div class="wechat-tips">
        <p>请点击右上方菜单</p>
        <p>选择在浏览器中打开</p>
      </div>
    </div>
    <div class="header">
      <div class="title">选择下载子系统</div>
      <div class="tips">请根据您的需求选择对应子系统进行下载</div>
    </div>

    <ul class="applist">
      <li
        class="list-item"
        v-for="item in appList"
        :key="item.appCode"
        @click="handleSelectApp(item)"
      >
        <div class="app-info">
          <img :src="item.previewLogo" alt />
          <p class="app-name">{{ item.appName }}</p>
        </div>
        <i class="el-icon-arrow-right"></i>
      </li>
    </ul>

    <router-view></router-view>
  </div>
</template>

<script>
import loginApi from 'api/login.js';

export default {
  data() {
    return {
      appList: [],
      wechatFlag: false
    };
  },
  created() {
    this.getAppListData();
    this.isWechat();
  },
  methods: {
    // 检测是否为微信扫码
    isWechat() {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf('micromessenger') > -1) {
        this.wechatFlag = true;
      } else {
        this.wechatFlag = false;
      }
    },
    // 获取app列表
    getAppListData() {
      loginApi.getAppList().then(res => {
        if (res.data.code === 200) {
          this.appList = res.data.data;
        }
        // else {
        //   this.$message.error(res.data.message);
        // }
      });
    },
    // app点击事件
    handleSelectApp(item) {
      this.$router.push({
        path: `/applist/appdown`,
        name: 'AppDownloadPage',
        params: item
      });
    }
  }
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
ul li {
  list-style: none;
}
.applist-wrapper {
  // padding: 0 10px;
  position: relative;
  height: 100vh;
  overflow-y: auto;

  .wechat-mask {
    z-index: 200;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);

    .wechat-tips {
      position: absolute;
      top: 15%;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 80%;
      height: 100px;
      border: 1px dashed #fff;
      color: #fff;
      font-size: 20px;
      text-align: center;

      p {
        margin: 5px 0;
      }
    }
  }

  .header {
    padding: 0 10px;
    padding-top: 64px;
    margin-bottom: 33px;

    .title {
      height: 42px;
      line-height: 42px;
      font-size: 30px;
      color: #333333;
    }

    .tips {
      height: 20px;
      line-height: 20px;
      margin-top: 10px;
      font-size: 14px;
      color: #999999;
    }
  }

  .applist {
    padding: 0 10px;
    padding-bottom: 10px;
    background-color: #f4f4f4;

    .list-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 72px;
      margin: 10px 0;
      background-color: #fff;
      border-radius: 5px;
      padding: 0 10px;

      .app-info {
        width: calc(~'100% - 16px');
        display: flex;
        height: 46px;
        line-height: 46px;

        img {
          width: 46px;
          height: 46px;
        }

        .app-name {
          width: calc(~'100% - 62px');
          margin-left: 16px;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #333333;
          overflow: hidden;
          word-break: keep-all;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }

    .list-item:active {
      background-color: rgba(240, 240, 240, 0.5);
    }
  }
}
</style>
